import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeacherTimetable } from "../TimeTable/redux/myTimetableSlice";
import { fetchSessionsThunk } from "../../AcademicCalendar/redux/academicCalendarSlice";
import testSyllabus from "../Syllabus";
import { useNavigate } from "react-router-dom";
import { getSyllabusThunk } from "../redux/syllabusthunk";
import { fetchTeachers } from "../../SchoolModule/teachers/redux/teacherSlice";
import { getMasterDataByUserId } from "../../../pages/masterData/redux/masterDataThunk";
import userStore from "../../../zustand/userStore";
import { startTour, setStepIndex, stopTour } from "../../../redux/globalJoyrideSlice";
import { adminSyllabusTourSteps,adminSyllabusTourSteps2 } from "../../../tour/teacherPlanerTourSteps";


export default function AdminSyllabus() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { syllabusData } = useSelector((state) => state.syllabus);
  const { teacherPeriods, loading } = useSelector((state) => state.myTimetable);
  const { teachers } = useSelector((state) => state.teachers);
  const sessions = useSelector((state) => state.academicCalendar.sessions);

  const [chapterPlan, setChapterPlan] = useState([]);
  const [formData, setFormData] = useState({
    selectedClass: "",
    selectedSubject: "",
    noData: false,
  });
  const masterData = useSelector((state) => state.masterData);
  const schoolId = masterData?.school_id;
  const userData = userStore((state) => state.user);
  const location = useLocation();


  const [selectedTeacherId, setSelectedTeacherId] = useState("");
  
const { stepIndex, run } = useSelector(
  (state) => state.globalJoyride
);

  useEffect(() => {
    dispatch(getMasterDataByUserId(userData?.id));
  }, [dispatch]);

  useEffect(() => {
    if (schoolId) {
      dispatch(fetchTeachers());
    }
  }, [dispatch, schoolId]);

  useEffect(() => {
    if (selectedTeacherId) {
      dispatch(fetchSessionsThunk());
      dispatch(getSyllabusThunk(selectedTeacherId));
      dispatch(fetchTeacherTimetable(selectedTeacherId));
    }
  }, [dispatch, selectedTeacherId]);
useEffect(() => {
  dispatch(
    startTour({ 
      steps: adminSyllabusTourSteps(),
    })
  );
}, [dispatch]);


useEffect(() => {
  if (location.state?.startTeacherTour && teachers.length > 0) {
    dispatch(
      startTour({
        activeTour: "admin-syllabus-select-flow",
        steps: adminSyllabusTourSteps2(),
      })
    );
    dispatch(setStepIndex(0));
  }
}, [dispatch, location.state, teachers.length]);

useEffect(() => {
  // Only move to step 1 if we have a teacher selected AND class data is ready
  if (selectedTeacherId && teacherPeriods?.classes?.length > 0) {
    const t = setTimeout(() => {
      dispatch(setStepIndex(1));
    }, 100); // Give it a slight delay (100ms) to ensure DOM is painted
    return () => clearTimeout(t);
  }
}, [selectedTeacherId, teacherPeriods, dispatch]);

useEffect(() => {
  // index of timetable-table-step (last step)
  const LAST_STEP_INDEX = 4;

  if (run && stepIndex === LAST_STEP_INDEX) {
    // user clicked NEXT on timetable step
    dispatch(stopTour());
    navigate("/weeklyLessons");
  }
}, [stepIndex, run, dispatch, navigate]);
  useEffect(() => {
    // const first = Array.isArray(syllabusData) ? syllabusData[0] : syllabusData;

    if (
      !(teacherPeriods?.classes?.length > 0) &&
      !(teacherPeriods.subjects?.length > 0)
    ) {
      return;
    }

    const selectedClassId = formData.selectedClass;
    const selectedSubjectId = formData.selectedSubject;
    const first = Array.isArray(syllabusData)
      ? syllabusData.find(
          (item) =>
            String(item.class_id) === selectedClassId &&
            String(item.subject_id) === selectedSubjectId
        )
      : null;

    if (!first) {
      setChapterPlan([]);
      setFormData((prev) => ({ ...prev, noData: true }));
      return;
    }

    const chapters = first?.syllabus ? JSON.parse(first.syllabus) : [];
    const session = sessions.find((s) => s.status === "active");
    if (!session) return;
    const start = moment(session.start_date);
    const end = moment(session.end_date);
    const totalDays = end.diff(start, "days") + 1;
    const allDates = [];
    for (let i = 0; i < totalDays; i++) {
      const day = start.clone().add(i, "days");
      allDates.push({
        date: day,
        dayName: day.format("dddd"),
      });
    }
    const periods = first?.periods ? JSON.parse(first.periods) : [];
    const subjectPeriods = periods.filter(
      (p) =>
        Number(p.subject_id) === Number(first.subject_id) &&
        p.class_name === first.class_name
    );
    const flatPeriodList = [];
    allDates.forEach(({ date, dayName }) => {
      const dayPeriods = subjectPeriods.filter((p) => p.day === dayName);
      dayPeriods.forEach((p) => {
        flatPeriodList.push({ ...p, date: date.format("YYYY-MM-DD") });
      });
    });

    // Assign chapters to periods
    const plan = [];
    let index = 0;
    chapters.forEach((chapter, chIndex) => {
      for (let i = 0; i < Number(chapter.numberofperiods); i++) {
        if (index >= flatPeriodList.length) break;

        plan.push({
          sno: plan.length + 1,
          period: flatPeriodList[index],
          className: flatPeriodList[index].class_name,
          subjectName: flatPeriodList[index].subject_name,
          chapter: chapter.chapter,
          homework: "",
        });

        index++;
      }
    });

    // Assign "Revision" for leftover periods
    for (let i = index; i < flatPeriodList.length; i++) {
      plan.push({
        sno: plan.length + 1,
        period: flatPeriodList[i],
        className: flatPeriodList[i].class_name,
        subjectName: flatPeriodList[i].subject_name,
        chapter: "Revision",
        homework: "",
      });
    }

    setChapterPlan(plan);
    setFormData((prev) => ({ ...prev, noData: plan.length === 0 }));
  }, [syllabusData, sessions, formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="px-5" style={{ fontFamily: "Segoe UI, sans-serif" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        {/* <h2>📅 Syllabus Plan Table</h2> */}
        <button
        data-tour="add-syllabus-btn"
          className="btn btn-primary btn-sm "
          onClick={() => {navigate("/adminUploadSyllabus")
            dispatch(stopTour())
          }
          }
          style={{
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          ➕ Add Syllabus
        </button>
      </div>

      <div className="filter-container mb-3">
        <label>
          <select
          data-tour="select-teacher-step"
            className="form-select"
            value={selectedTeacherId}
            onChange={(e) => {
              setSelectedTeacherId(e.target.value);
            }}
          >
            <option value="">Select a teacher</option>
            {Array.isArray(teachers) && teachers.length > 0 ? (
              teachers.map((teacher) => (
                <option key={teacher.teacher_id} value={teacher.teacher_id}>
                  {teacher.name}
                </option>
              ))
            ) : (
              <option disabled>No teachers found</option>
            )}
          </select>
        </label>
      </div>
      <div style={{ display: "flex", gap: "20px" }}>
        {selectedTeacherId && (
          <>
            <div style={styles.formGroupStyle}>
              <label htmlFor="selectedClass" style={styles.labelStyle}>
                Select Class
              </label>
              <select
              data-tour="select-class-step"
                name="selectedClass"
                value={formData.selectedClass}
                onChange={(e) => {
    handleChange(e);
    dispatch(setStepIndex(2)); // 👉 move to subject step
  }}
                required
                style={styles.inputStyle}
              >
                <option value="">-- Select Class --</option>
                {teacherPeriods?.classes?.map((cls, index) => (
                  <option key={index} value={cls.class_id}>
                    {cls.class_name}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.formGroupStyle}>
              <label htmlFor="selectedSubject" style={styles.labelStyle}>
                Select Subject
              </label>
              <select
              data-tour="select-subject-step"
                name="selectedSubject"
                value={formData.selectedSubject}
                onChange={(e) => {
    handleChange(e);
    
    dispatch(setStepIndex(3));
  }}
                required
                style={styles.inputStyle}
              >
                <option value="">-- Select Subject --</option>
                {teacherPeriods?.subjects?.map((subj, index) => (
                  <option key={index} value={subj.subject_id}>
                    {subj.subject_name}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
      </div>

      <div
      data-tour="syllabus-plan-table"
       style={{ maxHeight: "500px", overflowY: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "900px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#e3f2fd" }}>
              <th
                style={{
                  ...styles.th,
                  position: "sticky",
                  top: 0,
                  background: "#e3f2fd",
                  zIndex: 2,
                }}
              >
                S.No
              </th>
              <th
                style={{
                  ...styles.th,
                  position: "sticky",
                  top: 0,
                  background: "#e3f2fd",
                  zIndex: 2,
                }}
              >
                Period
              </th>
              <th
                style={{
                  ...styles.th,
                  position: "sticky",
                  top: 0,
                  background: "#e3f2fd",
                  zIndex: 2,
                }}
              >
                Class
              </th>
              <th
                style={{
                  ...styles.th,
                  position: "sticky",
                  top: 0,
                  background: "#e3f2fd",
                  zIndex: 2,
                }}
              >
                Subject
              </th>
              <th
                style={{
                  ...styles.th,
                  position: "sticky",
                  top: 0,
                  background: "#e3f2fd",
                  zIndex: 2,
                }}
              >
                Chapter
              </th>
              <th
                style={{
                  ...styles.th,
                  position: "sticky",
                  top: 0,
                  background: "#e3f2fd",
                  zIndex: 2,
                }}
              >
                Homework / Assignment
              </th>
              <th
                style={{
                  ...styles.th,
                  position: "sticky",
                  top: 0,
                  background: "#e3f2fd",
                  zIndex: 2,
                }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {formData.noData ? (
              <tr>
                <td
                  colSpan="7"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No data found
                </td>
              </tr>
            ) : (
              chapterPlan.map((row) => (
                <tr key={row.sno}>
                  <td style={styles.td}>{row.sno}</td>
                  <td style={styles.td}>
                    {row.period.period_name} <br />
                    <small>
                      {row.period.day}, {row.period.date}
                    </small>
                  </td>
                  <td style={styles.td}>{row.className}</td>
                  <td style={styles.td}>{row.subjectName}</td>
                  <td style={styles.td}>{row.chapter}</td>
                  <td style={styles.td}>{row.homework || "-"}</td>
                  <td style={styles.td}>
                    <i
                      className="fa fa-edit"
                      title="Edit"
                      style={styles.icon}
                    ></i>
                    <i
                      className="fa fa-refresh"
                      title="Update Status"
                      style={styles.icon}
                    ></i>
                    <i
                      className="fa fa-eye"
                      title="View"
                      style={styles.icon}
                      onClick={() =>
                        alert(
                          `Class: ${row.className}\nSubject: ${row.subjectName}\nChapter: ${row.chapter}\nDate: ${row.period.date}`
                        )
                      }
                    ></i>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  th: {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "left",
  },
  td: {
    border: "1px solid #ccc",
    padding: "10px",
  },
  icon: {
    fontSize: "16px",
    cursor: "pointer",
    color: "#1976d2",
    transition: "color 0.3s",
  },
  inputStyle: {
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    maxWidth: "400px",
  },

  formGroupStyle: {
    minWidth: "25%",
    marginBottom: "15px",
  },

  labelStyle: {
    fontWeight: "bold",
    marginBottom: "5px",
  },
};
